import { FC } from "react";
import { Platform } from "react-native";
import * as LabelPrimitive from "@rn-primitives/label";

import { cn } from "@/utils/tailwind";

import { VnText, VnTextPropsType } from "./VnText/VnText";

type VnLabelPropsType = LabelPrimitive.TextProps & VnTextPropsType;

export const VnLabel: FC<VnLabelPropsType> = ({
  onPress,
  onLongPress,
  onPressIn,
  onPressOut,
  disabled,
  ...props
}) => {
  return (
    <LabelPrimitive.Root
      className={cn(
        "flex shrink select-none flex-row items-center gap-2",
        Platform.select({
          web: cn(
            "leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
            onPress && !disabled ? "cursor-pointer" : "pointer-events-none",
          ),
        }),
        disabled && "opacity-50",
      )}
      onPress={onPress}
      onLongPress={onLongPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      disabled={disabled}>
      <LabelPrimitive.Text asChild>
        <VnText variant="lgMedium" {...props} />
      </LabelPrimitive.Text>
    </LabelPrimitive.Root>
  );
};
